module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "vux-flexbox",
    class: {
      'vux-flex-col': _vm.orient === 'vertical', 'vux-flex-row': _vm.orient === 'horizontal'
    },
    style: (_vm.styles)
  }, [_vm._t("default")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3bf2d162"}!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./~/vux/src/components/flexbox/flexbox.vue
// module id = 493
// module chunks = 4